// AXIOM — i18n
// Japanese primary, English secondary. Zero external assets, zero deps.
//
//   import { t, setLang, applyI18n } from './i18n.js';
//   el.textContent = t('hud.wave');
//   <span data-i18n="hud.wave"></span>   ->  applyI18n(root)
//
// Interpolation: t('death.digits', { n: 42 })  with "{n}" in the string.

const STORE_KEY = 'axiom.lang';

export const LANGS = ['ja', 'en'];

const DICT = {
  ja: {
    'lang.name': '日本語',
    'lang.other': 'ENGLISH',

    // ── HUD ────────────────────────────────────────────────
    'hud.wave': 'ウェーブ',
    'hud.level': 'レベル',
    'hud.hp': '生命値',
    'hud.ammo': '装弾',
    'hud.reserve': '予備',
    'hud.reloading': 'リロード中',
    'hud.reload': 'R でリロード',
    'hud.empty': '弾切れ',
    'hud.chain': '連鎖',
    'hud.kills': '撃破',
    'hud.bag': '手持ち',
    'hud.dps': '毎秒',
    'hud.peak': '最大',
    'hud.boss': '定理',
    'hud.bossSub': 'THEOREM',
    'hud.waveIncoming': 'ウェーブ {n}',
    'hud.waveSub': '接近中',
    'hud.waveClear': 'ウェーブ {n} 制圧',
    'hud.bossIncoming': '定理 出現',
    'hud.bossSubBanner': '通常のダメージは通用しない',
    'hud.prime': '素数',
    'hud.critical': '臨界',
    'hud.headshot': '頭部',
    'hud.overkill': '過剰破壊',
    'hud.levelup': 'レベル {n}',
    'hud.levelupSub': '公理を選択せよ',
    'hud.pickup': '{s} を取得',
    'hud.slotFull': 'スロット満杯',
    'hud.lowhp': '危険',

    // ── Formula bar ────────────────────────────────────────
    'formula.title': '式',
    'formula.titleSub': 'EXPRESSION',
    'formula.live': 'ライブ',
    'formula.expected': '期待値',
    'formula.rate': '発射レート',
    'formula.dragHint': 'ドラッグで並べ替え — 順序が結果を変える',
    'formula.dragHint2': 'SHIFT + ← → でも移動',
    'formula.empty': '空きスロット',
    'formula.base': '基礎値',
    'formula.previewing': 'プレビュー',
    'formula.committed': '確定',
    'formula.noChange': '変化なし',
    'formula.slot': 'スロット {n}',

    // ── Perk draft ─────────────────────────────────────────
    'draft.title': '公理を選べ',
    'draft.titleSub': 'SELECT AN AXIOM',
    'draft.hint': '1 / 2 / 3 キー、またはクリック',
    'draft.reroll': '引き直し',
    'draft.banish': '追放',
    'draft.rerollLeft': '残り {n}',
    'draft.rarity.common': '基本',
    'draft.rarity.rare': '希少',
    'draft.rarity.epic': '特異',
    'draft.rarity.legendary': '公理級',
    'draft.level': 'レベル {n} 到達',

    // ── Kill feed ──────────────────────────────────────────
    'feed.killed': '撃破',
    'feed.perk': '公理獲得',
    'feed.token': 'トークン',
    'feed.wave': 'ウェーブ',
    'feed.prime': '素数臨界',
    'feed.chain': '連鎖 {n}',

    // ── Main menu ──────────────────────────────────────────
    'menu.tagline': '銃ではなく、式を撃て。',
    'menu.taglineSub': 'YOU DO NOT CARRY A GUN. YOU CARRY AN EXPRESSION.',
    'menu.start': '出撃',
    'menu.startSub': 'ENGAGE',
    'menu.settings': '設定',
    'menu.settingsSub': 'SETTINGS',
    'menu.records': '記録',
    'menu.recordsSub': 'RECORDS',
    'menu.quit': '終了',
    'menu.build': 'ビルド',
    'menu.seed': 'シード',
    'menu.best': '最高記録',
    'menu.bestNone': '記録なし',

    // ── Settings ───────────────────────────────────────────
    'settings.title': '設定',
    'settings.titleSub': 'SETTINGS',
    'settings.sensitivity': 'マウス感度',
    'settings.fov': '視野角',
    'settings.quality': '描画品質',
    'settings.volume': '音量',
    'settings.language': '言語',
    'settings.invertY': 'Y軸反転',
    'settings.controls': 'キー／ゲームパッド',
    'settings.controlsSub': 'INPUT CONFIG',
    'settings.controlsOpen': '設定を開く',
    'settings.controlsReset': '入力を既定値に戻す',
    'settings.padSensitivity': '右スティック感度',
    'settings.padConnected': '接続中',
    'settings.padWaiting': '未接続 — 接続後にボタンを押してください',
    'settings.padMapTitle': '標準ゲームパッド',
    'settings.padMap': '左STICK 移動 · 右STICK 視点 · RT 射撃 · LT ADS · A ジャンプ／決定 · B しゃがみ／戻る · X リロード · Y 射撃モード · VIEW 鍛造 · MENU 一時停止',
    'settings.bindHint': '変更する操作を選び、次のキーを押してください。重複時はキーを入れ替えます。ESCで中止。',
    'settings.pressKey': 'キーを入力…',
    'settings.back': '戻る',
    'settings.reset': '既定値に戻す',
    'settings.q.low': '低',
    'settings.q.medium': '中',
    'settings.q.high': '高',
    'settings.q.ultra': '最高',
    'settings.on': 'ON',
    'settings.off': 'OFF',
    'controls.forward': '前進', 'controls.back': '後退', 'controls.left': '左移動', 'controls.right': '右移動',
    'controls.jump': 'ジャンプ', 'controls.sprint': 'スプリント', 'controls.crouch': 'しゃがみ／スライド',
    'controls.reload': 'リロード', 'controls.fireMode': '射撃モード', 'controls.forge': '鍛造',
    'controls.pause': '一時停止', 'controls.help': '操作説明',

    // ── Pause ──────────────────────────────────────────────
    'pause.title': '一時停止',
    'pause.titleSub': 'PAUSED',
    'pause.resume': '再開',
    'pause.settings': '設定',
    'pause.restart': 'やり直す',
    'pause.quit': 'メニューへ',

    // ── Death ──────────────────────────────────────────────
    'death.title': '証明終了',
    'death.titleSub': 'Q.E.D.',
    'death.formulaLabel': 'あなたの最終数式',
    'death.formulaLabelSub': 'YOUR FINAL EXPRESSION',
    'death.reached': '到達桁数',
    'death.wave': '到達ウェーブ',
    'death.peak': '最大ダメージ',
    'death.total': '総ダメージ',
    'death.kills': '総撃破',
    'death.chain': '最長連鎖',
    'death.primes': '素数臨界',
    'death.accuracy': '命中率',
    'death.time': '生存時間',
    'death.axiom': '公理ポイント',
    'death.axiomSub': 'AXIOM POINTS EARNED',
    'death.retry': '再挑戦',
    'death.menu': 'メニュー',
    'death.hint': 'スクリーンショットを撮って共有せよ',

    'common.close': '閉じる',
    'common.on': '有効',
    'common.off': '無効',
  },

  en: {
    'lang.name': 'ENGLISH',
    'lang.other': '日本語',

    'hud.wave': 'WAVE',
    'hud.level': 'LEVEL',
    'hud.hp': 'VITALS',
    'hud.ammo': 'MAG',
    'hud.reserve': 'RES',
    'hud.reloading': 'RELOADING',
    'hud.reload': 'PRESS R',
    'hud.empty': 'EMPTY',
    'hud.chain': 'CHAIN',
    'hud.kills': 'KILLS',
    'hud.bag': 'BAG',
    'hud.dps': 'DPS',
    'hud.peak': 'PEAK',
    'hud.boss': 'THEOREM',
    'hud.bossSub': '定理',
    'hud.waveIncoming': 'WAVE {n}',
    'hud.waveSub': 'INBOUND',
    'hud.waveClear': 'WAVE {n} CLEARED',
    'hud.bossIncoming': 'THEOREM MANIFEST',
    'hud.bossSubBanner': 'ORDINARY DAMAGE WILL NOT SUFFICE',
    'hud.prime': 'PRIME',
    'hud.critical': 'CRIT',
    'hud.headshot': 'HEAD',
    'hud.overkill': 'OVERKILL',
    'hud.levelup': 'LEVEL {n}',
    'hud.levelupSub': 'SELECT AN AXIOM',
    'hud.pickup': 'ACQUIRED {s}',
    'hud.slotFull': 'SLOTS FULL',
    'hud.lowhp': 'CRITICAL',

    'formula.title': 'EXPRESSION',
    'formula.titleSub': '式',
    'formula.live': 'LIVE',
    'formula.expected': 'EXPECTED',
    'formula.rate': 'FIRE RATE',
    'formula.dragHint': 'DRAG TO REORDER — ORDER CHANGES THE MATH',
    'formula.dragHint2': 'OR SHIFT + ← →',
    'formula.empty': 'EMPTY SLOT',
    'formula.base': 'BASE',
    'formula.previewing': 'PREVIEW',
    'formula.committed': 'COMMITTED',
    'formula.noChange': 'NO CHANGE',
    'formula.slot': 'SLOT {n}',

    'draft.title': 'SELECT AN AXIOM',
    'draft.titleSub': '公理を選べ',
    'draft.hint': 'PRESS 1 / 2 / 3 OR CLICK',
    'draft.reroll': 'REROLL',
    'draft.banish': 'BANISH',
    'draft.rerollLeft': '{n} LEFT',
    'draft.rarity.common': 'COMMON',
    'draft.rarity.rare': 'RARE',
    'draft.rarity.epic': 'EPIC',
    'draft.rarity.legendary': 'LEGENDARY',
    'draft.level': 'LEVEL {n} REACHED',

    'feed.killed': 'ELIMINATED',
    'feed.perk': 'AXIOM',
    'feed.token': 'TOKEN',
    'feed.wave': 'WAVE',
    'feed.prime': 'PRIME CRIT',
    'feed.chain': 'CHAIN {n}',

    'menu.tagline': 'YOU DO NOT CARRY A GUN. YOU CARRY AN EXPRESSION.',
    'menu.taglineSub': '銃ではなく、式を撃て。',
    'menu.start': 'ENGAGE',
    'menu.startSub': '出撃',
    'menu.settings': 'SETTINGS',
    'menu.settingsSub': '設定',
    'menu.records': 'RECORDS',
    'menu.recordsSub': '記録',
    'menu.quit': 'QUIT',
    'menu.build': 'BUILD',
    'menu.seed': 'SEED',
    'menu.best': 'PERSONAL BEST',
    'menu.bestNone': 'NO RECORD',

    'settings.title': 'SETTINGS',
    'settings.titleSub': '設定',
    'settings.sensitivity': 'SENSITIVITY',
    'settings.fov': 'FIELD OF VIEW',
    'settings.quality': 'QUALITY',
    'settings.volume': 'VOLUME',
    'settings.language': 'LANGUAGE',
    'settings.invertY': 'INVERT Y',
    'settings.controls': 'KEYS / GAMEPAD',
    'settings.controlsSub': '入力設定',
    'settings.controlsOpen': 'OPEN CONFIG',
    'settings.controlsReset': 'RESTORE INPUT DEFAULTS',
    'settings.padSensitivity': 'RIGHT STICK SENSITIVITY',
    'settings.padConnected': 'CONNECTED',
    'settings.padWaiting': 'NOT CONNECTED — PRESS A BUTTON AFTER CONNECTING',
    'settings.padMapTitle': 'STANDARD GAMEPAD',
    'settings.padMap': 'LEFT STICK Move · RIGHT STICK Look · RT Fire · LT ADS · A Jump/Confirm · B Crouch/Back · X Reload · Y Fire mode · VIEW Forge · MENU Pause',
    'settings.bindHint': 'Choose an action, then press a key. Conflicts swap keys. ESC cancels.',
    'settings.pressKey': 'PRESS A KEY…',
    'settings.back': 'BACK',
    'settings.reset': 'RESTORE DEFAULTS',
    'settings.q.low': 'LOW',
    'settings.q.medium': 'MEDIUM',
    'settings.q.high': 'HIGH',
    'settings.q.ultra': 'ULTRA',
    'settings.on': 'ON',
    'settings.off': 'OFF',
    'controls.forward': 'FORWARD', 'controls.back': 'BACK', 'controls.left': 'STRAFE LEFT', 'controls.right': 'STRAFE RIGHT',
    'controls.jump': 'JUMP', 'controls.sprint': 'SPRINT', 'controls.crouch': 'CROUCH / SLIDE',
    'controls.reload': 'RELOAD', 'controls.fireMode': 'FIRE MODE', 'controls.forge': 'FORGE',
    'controls.pause': 'PAUSE', 'controls.help': 'CONTROLS',

    'pause.title': 'PAUSED',
    'pause.titleSub': '一時停止',
    'pause.resume': 'RESUME',
    'pause.settings': 'SETTINGS',
    'pause.restart': 'RESTART',
    'pause.quit': 'MAIN MENU',

    'death.title': 'Q.E.D.',
    'death.titleSub': '証明終了',
    'death.formulaLabel': 'YOUR FINAL EXPRESSION',
    'death.formulaLabelSub': 'あなたの最終数式',
    'death.reached': 'ORDER OF MAGNITUDE',
    'death.wave': 'WAVE REACHED',
    'death.peak': 'PEAK DAMAGE',
    'death.total': 'TOTAL DAMAGE',
    'death.kills': 'TOTAL KILLS',
    'death.chain': 'LONGEST CHAIN',
    'death.primes': 'PRIME CRITS',
    'death.accuracy': 'ACCURACY',
    'death.time': 'SURVIVED',
    'death.axiom': 'AXIOM POINTS',
    'death.axiomSub': '公理ポイント獲得',
    'death.retry': 'RETRY',
    'death.menu': 'MAIN MENU',
    'death.hint': 'SCREENSHOT AND SHARE YOUR PROOF',

    'common.close': 'CLOSE',
    'common.on': 'ON',
    'common.off': 'OFF',
  },
};

let current = 'ja';
try {
  const saved = localStorage.getItem(STORE_KEY);
  if (saved && LANGS.includes(saved)) current = saved;
} catch { /* private mode */ }

const listeners = new Set();

export function getLang() { return current; }

export function setLang(lang) {
  if (!LANGS.includes(lang) || lang === current) return current;
  current = lang;
  try { localStorage.setItem(STORE_KEY, lang); } catch { /* noop */ }
  document.documentElement.setAttribute('lang', lang);
  document.documentElement.setAttribute('data-lang', lang);
  applyI18n(document);
  for (const fn of [...listeners]) { try { fn(lang); } catch (e) { console.error(e); } }
  return current;
}

export function toggleLang() { return setLang(current === 'ja' ? 'en' : 'ja'); }

export function onLangChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/** Translate. Missing keys fall back to EN, then to the key itself (visible in dev). */
export function t(key, vars) {
  let s = DICT[current]?.[key];
  if (s === undefined) s = DICT.en[key];
  if (s === undefined) return key;
  if (vars) {
    s = s.replace(/\{(\w+)\}/g, (m, k) => (vars[k] !== undefined ? String(vars[k]) : m));
  }
  return s;
}

/** Pick the language-appropriate field from a data object (perks: name/nameJa). */
export function pick(obj, base) {
  if (!obj) return '';
  const ja = obj[base + 'Ja'] ?? obj[base + 'JA'] ?? obj[base + '_ja'];
  if (current === 'ja' && ja) return ja;
  return obj[base] ?? ja ?? '';
}

/** Fill every [data-i18n] / [data-i18n-attr] under root. */
export function applyI18n(root = document) {
  const scope = root.querySelectorAll ? root : document;
  scope.querySelectorAll('[data-i18n]').forEach((el) => {
    const key = el.getAttribute('data-i18n');
    const raw = el.getAttribute('data-i18n-vars');
    let vars = null;
    if (raw) { try { vars = JSON.parse(raw); } catch { /* ignore */ } }
    el.textContent = t(key, vars);
  });
  scope.querySelectorAll('[data-i18n-attr]').forEach((el) => {
    // format: "attr:key,attr:key"
    for (const pairStr of el.getAttribute('data-i18n-attr').split(',')) {
      const [attr, key] = pairStr.split(':');
      if (attr && key) el.setAttribute(attr.trim(), t(key.trim()));
    }
  });
}

// Set the initial document attributes so CSS can switch font stacks immediately.
try {
  document.documentElement.setAttribute('lang', current);
  document.documentElement.setAttribute('data-lang', current);
} catch { /* SSR-safe */ }

export default { t, pick, setLang, getLang, toggleLang, onLangChange, applyI18n, LANGS };
